import type { quotes as enQuotes } from "../en/quotes";

export const quotes: typeof enQuotes = {
  pageHeading: "Preventivi",
  importedBanner: {
    summaryOne: "Importato {{count}} preventivo",
    summaryOther: "Importati {{count}} preventivi",
    skippedSuffix: " ({{count}} saltati per errori)",
  },
  bulkCanceledBanner: {
    summaryOne: "Annullato {{count}} preventivo",
    summaryOther: "Annullati {{count}} preventivi",
    skippedSuffix: " ({{count}} saltati — già in stato finale)",
  },
  actions: {
    newQuote: "Nuovo preventivo",
    bulkImport: "Importazione in blocco da CSV",
    exportCsv: "Esporta i filtrati in CSV",
  },
  filter: {
    heading: "Filtro",
    searchLabel: "Cerca numero / azienda / email acquirente / rif. esterno",
    searchPlaceholder: "es. Q-12, Acme, alice@",
    companyGidLabel: "GID azienda",
    fromLabel: "Da (AAAA-MM-GG)",
    toLabel: "A (AAAA-MM-GG)",
    statusLabel: "Stato",
    apply: "Applica filtro",
    clear: "Cancella",
  },
  emptyFiltered: {
    heading: "Nessun preventivo corrisponde ai filtri",
    body: "Prova a cancellare o ampliare i filtri per vedere più preventivi.",
  },
  emptyNoQuotes: {
    heading: "Nessun preventivo ancora",
    action: "Crea il tuo primo preventivo",
    body: "Crea il tuo primo preventivo e comparirà qui.",
  },
  list: {
    headingOne: "{{total}} preventivo",
    headingOther: "{{total}} preventivi",
    truncatedSuffix: " (visualizzati i primi {{shown}})",
    selectAriaLabel: "Seleziona {{number}} per l'azione in blocco",
    externalRef: "rif. est. {{number}}",
    unknownCompany: "(sconosciuta)",
    cancelSelected: "Annulla selezionati",
    cancelableHint: "Solo le righe in BOZZA/INVIATO/VISUALIZZATO sono selezionabili.",
    truncatedHint:
      "Restringi il filtro (stato, intervallo di date, azienda) per affinare la ricerca. La paginazione oltre i primi 50 arriva in un prossimo aggiornamento.",
  },
};
